module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_03_770_280_zh-hant-98c4ac3c83f72af3928d0524422456b9.jpg";